import React from "react";
import { useHistory } from "react-router-dom";
import Paper from "components/Paper";
import Text from "components/Text";
import Button from "components/Button";
import clsx from "clsx";

import styles from "./index.module.css";
const Step1 = () => {
    const history = useHistory();
    return (
        <div className={styles.step1Page}>
            <Paper className={styles.paper}>
                <Text className="mt-0" type={"h1"}>
                    Important de știut:
                </Text>
                <Text className="mt-0" type={"h3"}>
                    · Accesul în Biroul de Asistență se face doar pe baza unei programări
                    confirmate;
                </Text>
                <Text className="mt-0" type={"h3"}>
                    · Programarea este valabilă doar pentru data și ora specificate;
                </Text>
                <Text className="mt-0" type={"h3"}>
                    · Introducerea de date eronate atrage anularea automată a programării;
                </Text>
                <div
                    className={clsx(
                        styles.actionContainer,
                        styles.alignCenter,
                        styles.flexEnd,
                        styles.fullWidth
                    )}
                >
                    <Button
                        size="large"
                        label="Continuă ->"
                        onClick={() => history.push("/programare/step2")}
                    />
                </div>
            </Paper>
        </div>
    );
};

export default Step1;
